import styles from './HelpModal.module.css'

interface Props {
  onClose: () => void
}

export default function HelpModal({ onClose }: Props) {
  return (
    <div className={styles.overlay} onClick={e => { if (e.target === e.currentTarget) onClose() }}>
      <div className={styles.modal}>
        <h2>Query Parameters</h2>
        <p>Append these to the page URL to configure the connection.</p>

        <h3><span className={styles.paramName}>session_id</span></h3>
        <ul>
          <li>Join or create a named session. Multiple clients with the same ID share the conversation.</li>
          <li>Example: <code>?session_id=my-room</code></li>
          <li>Omit to auto-generate a UUID.</li>
        </ul>

        <h3><span className={styles.paramName}>mode</span></h3>
        <ul>
          <li>Controls which animation data this client receives in AudioAnimation messages.</li>
          <li><code>?mode=vertices</code> — receive only vertex positions.</li>
          <li><code>?mode=bsstream</code> — streaming mode with blendshape frames + audio chunks.</li>
          <li><code>?mode=vertstream</code> — streaming mode with vertex frames + audio chunks.</li>
          <li>Default — receive only blendshape weights.</li>
        </ul>

        <h3><span className={styles.paramName}>Transmission mode</span></h3>
        <ul>
          <li><code>?transmission=binary</code> — receive messages in binary format.</li>
          <li><code>?transmission=json</code> — receive messages in JSON format.</li>
        </ul>

        <h3><span className={styles.paramName}>Features</span></h3>
        <ul>
          <li><code>?features=storyteller</code> — enable story mode.</li>
        </ul>

        <h3>Examples</h3>
        <ul>
          <li><code>/?session_id=demo</code></li>
          <li><code>/?mode=vertices</code></li>
          <li><code>/?mode=bsstream</code></li>
          <li><code>/?session_id=demo&mode=vertices&features=storyteller</code></li>
        </ul>

        <button className={styles.closeBtn} onClick={onClose}>Close</button>
      </div>
    </div>
  )
}
